module.exports = __webpack_public_path__ + "img/search-fields.7a90a3de.png";